export default __webpack_public_path__ + "static/media/Hpr.30220460.jpg";